export default __webpack_public_path__ + "static/media/autodesk-revit-logo-brandlogos.net_3f4zcg8n5.241fd2a0.svg";